const Op = require("./Op.js");

const reg = {
  [Op.eq]: (targetVal, sourceVal) => {
    return targetVal === sourceVal;
  },

  [Op.like]: (targetVal, sourceVal) => {
    let reg = new RegExp(".*" + targetVal + ".*");
    return reg.test(sourceVal);
  }
};

export default reg;
